export const EDIT_USER_REQUEST = "EDIT_USER_REQUEST";
export const EDIT_USER_RECEIVE = "EDIT_USER_RECEIVE";
export const EDIT_USER_FAILURE = "EDIT_USER_FAILURE";
export const RESET_EDIT_USER = "RESET_EDIT_USER";
